import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalNavigationComponent } from './portal-navigation.component';
import { NavListModule } from '../components/nav-list/nav-list.module';
import { NavProfileListModule } from '../components/nav-profile-list/nav-profile-list.module';
import { MatIconModule } from '@angular/material/icon';
import { ExpandableNavListModule } from '../components/mobile-nav-list/expandable-nav-list.module';

@NgModule({
  declarations: [PortalNavigationComponent],
  imports: [
    CommonModule,
    NavListModule,
    NavProfileListModule,
    ExpandableNavListModule,
    MatIconModule,
  ],
  exports: [PortalNavigationComponent],
})
export class PortalNavigationModule {}
